import React from "react";
import PropTypes from "prop-types";
import { useBasicInfo } from "./hooks/useBasicInfo";
import { BasicInfoEditMode } from "./components/BasicInfoEditMode";
import { BasicInfoViewMode } from "./components/BasicInfoViewMode";
import { AccessErrorModal } from "../../../primary";
import { CustomerTabSkeleton } from "../../../common/CustomerTabSkeleton/CustomerTabSkeleton";
import { useLoading } from "../../../../hooks/useLoading";
import { LOADING_KEYS } from "../../../../constants/loadingKeys";
import { CUSTOMER_UPDATE_SUCCESS, UPDATE_FAILURE, SUCCESS_STATUS, ERROR_STATUS } from "../../../../constants";
import styles from "./BasicInfo.module.scss";

export function BasicInfo({ customerData }) {
  const hook = useBasicInfo({ customerData });
  const isDetailLoading = useLoading(LOADING_KEYS.GET_CUSTOMER_DETAIL);

  if (isDetailLoading) {
    return (
      <div className={styles.wrapper}>
        <CustomerTabSkeleton />
      </div>
    );
  }

  return (
    <div className={styles.wrapper}>
      {hook.saveStatus === SUCCESS_STATUS && <div className={`${styles.alert} ${styles.alert_success}`}>{CUSTOMER_UPDATE_SUCCESS}</div>}

      {hook.saveStatus === ERROR_STATUS && <div className={`${styles.alert} ${styles.alert_danger}`}>{UPDATE_FAILURE}</div>}

      {!hook.editable ? (
        <BasicInfoViewMode customerData={customerData} header={hook.header} extra={hook.extra} onEdit={hook.handleEdit} />
      ) : (
        <BasicInfoEditMode
          customerData={customerData}
          handleSubmit={hook.handleSubmit}
          doSubmit={hook.doSubmit}
          register={hook.register}
          errors={hook.errors}
          form={hook.form}
          extra={hook.extra}
          hasPermission={hook.hasPermission}
          submitErrors={hook.submitErrors}
          onFieldChange={hook.onFieldChange}
          header={hook.header}
          onToggleStatus={hook.onToggleStatus}
          onSessionTimeoutChange={hook.onSessionTimeoutChange}
          onSessionTimeoutTypeChange={hook.onSessionTimeoutTypeChange}
          previewImg={hook.previewImg}
          setPreviewImg={hook.setPreviewImg}
          buttonState={hook.buttonState}
          setButtonState={hook.setButtonState}
          onCancel={hook.handleEdit}
          saveLoading={hook.saveLoading}
        />
      )}

      {hook.accessError && <AccessErrorModal />}
    </div>
  );
}

BasicInfo.propTypes = {
  customerData: PropTypes.object,
};
